/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Map_Svg_DescriptionInputs */

const en_map_svg_description = /** @type {(inputs: Map_Svg_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Five rings around Nexxt: Tomorrow with Backstage and Guestlist, brands and suppliers with Atelier, retailers and buyers with Frontrow, and the systems of the world through TIL.`)
};

/**
* | output |
* | --- |
* | "Five rings around Nexxt: Tomorrow with Backstage and Guestlist, brands and suppliers with Atelier, retailers and buyers with Frontrow, and the systems of the..." |
*
* @param {Map_Svg_DescriptionInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const map_svg_description = /** @type {((inputs?: Map_Svg_DescriptionInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Map_Svg_DescriptionInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_map_svg_description(inputs)
});